
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/sandbox/profiles",
      function () {
        return require("private-next-pages/docs/sandbox/profiles.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/sandbox/profiles"])
      });
    }
  